module.exports = "/assets/rc_share.png?YDSQyJY";